import deviceEvents from './devices'
import trackEvents from './tracks'

export default {
  ...deviceEvents,
  ...trackEvents
}
